/* Hero «de noche» (v7): cantidad (1 o 2) con el total en el botón, el regalo y la nieve lenta.
   Estados por URL: ?regalo=1 (enseña el regalo de luces LED; apagado porque el proveedor actual no las vende
   y llegarían en otro paquete) · ?precio=599 (precio anterior). */
(() => {
  const qs = new URLSearchParams(location.search);
  const HERO = document.querySelector("[data-hero]");
  const UNIDAD = HERO ? Number(HERO.dataset.heroPrecio) : 0;
  const DESC = HERO ? (Number(HERO.dataset.descuento2) || 15) / 100 : 0.15; // descuento automático de Shopify al llevar 2, nunca a mano // el 2.º al 50 %. En Shopify: descuento automático «Compra X, llévate Y» (1 + 1 al 50 %), nunca a mano
  const BASE = HERO ? HERO.dataset.base : "#";
  const AGOTADO = !!(HERO && HERO.dataset.agotado);
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => [...el.querySelectorAll(s)];
  const pesos = (n) => "$" + n.toLocaleString("es-MX", { minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2 });
  const ahorro = UNIDAD * 2 * DESC;
  const total = (n) => (n === 2 ? UNIDAD * 2 - ahorro : UNIDAD);

  function pintarCantidad(n) {
    $$("[data-cantidad] button").forEach((b) => b.setAttribute("aria-checked", String(Number(b.dataset.n) === n)));
    $$("[data-total]").forEach((el) => (el.textContent = "· " + pesos(total(n))));
    $$(".barra [data-precio-completo]").forEach((el) => (el.textContent = pesos(total(n)) + " MXN"));
    if (!AGOTADO) $$("[data-comprar]").forEach((a) => (a.href = `${BASE}:${n}`));
  }

  function iniciarCantidad() {
    const g = $("[data-cantidad]");
    if (!g) return;
    $$("[data-precio-n]").forEach((el) => (el.textContent = pesos(total(Number(el.dataset.precioN)))));
    $$("[data-ahorro]").forEach((el) => (el.textContent = "Ahorras " + pesos(ahorro)));
    $$("[data-doble]").forEach((el) => (el.textContent = pesos(UNIDAD * 2)));
    $$("button", g).forEach((b) => b.addEventListener("click", () => pintarCantidad(Number(b.dataset.n))));
    g.addEventListener("keydown", (e) => {
      if (!["ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown"].includes(e.key)) return;
      e.preventDefault();
      const actual = Number($("[aria-checked='true']", g).dataset.n);
      const n = actual === 1 ? 2 : 1;
      pintarCantidad(n);
      $(`[data-n='${n}']`, g).focus();
    });
    pintarCantidad(2); // la oferta del 2.º al 50 % viene elegida
  }

  /* Nieve: pocos copos, lentos, detrás del contenido. Semilla fija para que las capturas sean iguales. */
  function iniciarNieve() {
    const caja = $(".hero__nieve"), hero = $(".hero--noche");
    if (!caja || !hero) return;
    let s = 7;
    const r = () => ((s = (s * 9301 + 49297) % 233280) / 233280);
    const n = innerWidth >= 900 ? 22 : 14;
    for (let i = 0; i < n; i++) {
      const lejos = r() < 0.45;
      const f = document.createElement("i");
      const dur = (lejos ? 16 : 11) + r() * 6;
      f.style.cssText = `--x:${(r() * 100).toFixed(1)}%;--s:${(lejos ? 2.5 : 4) + r() * 3}px;--o:${(lejos ? .35 : .6) + r() * .25};--b:${lejos ? 1 : 0}px;--d:${dur.toFixed(1)}s;--r:${(-r() * dur).toFixed(1)}s`;
      caja.appendChild(f);
    }
    if ("IntersectionObserver" in window) new IntersectionObserver(([e]) => hero.classList.toggle("hero--fuera", !e.isIntersecting)).observe(hero);
  }

  document.addEventListener("DOMContentLoaded", () => {
    if (qs.get("regalo") !== "1") $$("[data-regalo]").forEach((el) => el.remove());
    iniciarCantidad();
    iniciarNieve();
  });
})();
